module.exports = {
  /**
   * Given a headers object retrieve the contents of a header out of it via a case-insensitive key.
   *
   * @param {object} headers
   * @param {string} name
   * @return {string}
   */
  getHeader: function getHeader(headers, name) {
    return headers[Object.keys(headers).find(function (k) {
      return k.toLowerCase() === name.toLowerCase();
    })];
  },

  /**
   * Given a headers object retrieve a specific header out of it via a case-insensitive key.
   *
   * @param {object} headers
   * @param {string} name
   * @return {string}
   */
  getHeaderName: function getHeaderName(headers, name) {
    // eslint-disable-next-line array-callback-return
    return Object.keys(headers).find(function (k) {
      if (k.toLowerCase() === name.toLowerCase()) {
        return k;
      }
    });
  },

  /**
   * Determine if a given case-insensitive header exists within a header object.
   *
   * @param {object} headers
   * @param {string} name
   * @return {(integer|boolean)}
   */
  hasHeader: function hasHeader(headers, name) {
    return Boolean(Object.keys(headers).find(function (k) {
      return k.toLowerCase() === name.toLowerCase();
    }));
  }
};